import { useEffect, type FC } from 'react';
import type { Verification } from './types';
import { HOTJAR_CERTSY_SKILLS_VIEWED } from 'src/constants/hotjar';
import { updateIntercomMarkDataAttributeTrue } from 'src/modules/intercom';
import { sendHotjarTag } from 'src/utils/hotjar';
import { intercomMessageKeys } from './IntercomMessageKeys';
import { VerificationDetailsTooltip } from './VerificationDetailsTooltip';
import { Bleed, Tag } from 'braid-design-system';
import { IconCertifiedWithIntercom } from './IconCertifiedWithIntercom';

interface QuestionnaireSubmissionVerifiedTagProps {
  verifications: Verification[];
  answerText: string;
  hideTooltip: boolean;
}

export const QuestionnaireSubmissionVerifiedTag: FC<
  QuestionnaireSubmissionVerifiedTagProps
> = (props) => {
  const { answerText, verifications, hideTooltip } = props;
  const hasSeenCertsyAssessments = 'has_seen_certsy_assessments';

  useEffect(() => {
    if (!intercomMessageKeys[hasSeenCertsyAssessments]) {
      intercomMessageKeys[hasSeenCertsyAssessments] = true;
      updateIntercomMarkDataAttributeTrue(hasSeenCertsyAssessments);
      sendHotjarTag(HOTJAR_CERTSY_SKILLS_VIEWED);
    }
  }, []);

  const verifiedTag = (
    <Bleed vertical="xsmall">
      <Tag
        icon={<IconCertifiedWithIntercom />}
        size="small"
        data={{ cy: 'custom-skill-pill' }}
      >
        {answerText}
      </Tag>
    </Bleed>
  );

  if (hideTooltip) {
    return verifiedTag;
  }

  return (
    <VerificationDetailsTooltip verifications={verifications}>
      {verifiedTag}
    </VerificationDetailsTooltip>
  );
};
